import _definePage_default_0 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/[...error].vue?definePage&vue'
import _definePage_default_3 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/ancient-student/[id].vue?definePage&vue'
import _definePage_default_4 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/callback.vue?definePage&vue'
import _definePage_default_5 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/cgu.vue?definePage&vue'
import _definePage_default_6 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/company/[id].vue?definePage&vue'
import _definePage_default_7 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/company/register/[id].vue?definePage&vue'
import _definePage_default_8 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/home.vue?definePage&vue'
import _definePage_default_9 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/inscription.vue?definePage&vue'
import _definePage_default_10 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/legal.vue?definePage&vue'
import _definePage_default_11 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/logout.vue?definePage&vue'
import _definePage_default_12 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/student/[id].vue?definePage&vue'
import _definePage_default_13 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/student/register/[id].vue?definePage&vue'
import _definePage_default_14 from 'D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/table-program.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'index',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/ancient-student',
    /* internal name: 'ancient-student' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'ancient-student-id',
        component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/ancient-student/[id].vue'),
        /* no children */
      },
  _definePage_default_3
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/callback',
    name: 'callback',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/callback.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  _mergeRouteRecord(
  {
    path: '/cgu',
    name: 'cgu',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/cgu.vue'),
    /* no children */
  },
  _definePage_default_5
  ),
  {
    path: '/company',
    /* internal name: 'company' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'company-id',
        component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/company/[id].vue'),
        /* no children */
      },
  _definePage_default_6
  ),
      {
        path: 'register',
        /* internal name: 'company-register' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'company-register-id',
            component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/company/register/[id].vue'),
            /* no children */
          },
  _definePage_default_7
  )
        ],
      }
    ],
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/dashboard.vue'),
    /* no children */
  },
  {
    path: '/establishments',
    name: 'establishments',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/establishments.vue'),
    /* no children */
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/faq.vue'),
    /* no children */
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/help.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/home',
    name: 'home',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/home.vue'),
    /* no children */
  },
  _definePage_default_8
  ),
  _mergeRouteRecord(
  {
    path: '/inscription',
    name: 'inscription',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/inscription.vue'),
    /* no children */
  },
  _definePage_default_9
  ),
  _mergeRouteRecord(
  {
    path: '/legal',
    name: 'legal',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/legal.vue'),
    /* no children */
  },
  _definePage_default_10
  ),
  _mergeRouteRecord(
  {
    path: '/logout',
    name: 'logout',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/logout.vue'),
    /* no children */
  },
  _definePage_default_11
  ),
  {
    path: '/profile',
    name: 'profile',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/profile.vue'),
    /* no children */
  },
  {
    path: '/reglement',
    name: 'reglement',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/reglement.vue'),
    /* no children */
  },
  {
    path: '/report',
    /* internal name: 'report' */
    /* no component */
    children: [
      {
        path: 'school',
        /* internal name: 'report-school' */
        /* no component */
        children: [
          {
            path: ':program',
            /* internal name: 'report-school-program' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'report-school-program-id',
                component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/report/school/[program]/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/student',
    /* internal name: 'student' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'student-id',
        component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/student/[id].vue'),
        /* no children */
      },
  _definePage_default_12
  ),
      {
        path: 'register',
        /* internal name: 'student-register' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'student-register-id',
            component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/student/register/[id].vue'),
            /* no children */
          },
  _definePage_default_13
  )
        ],
      }
    ],
  },
  {
    path: '/survey',
    /* internal name: 'survey' */
    /* no component */
    children: [
      {
        path: ':id',
        name: 'survey-id',
        component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/survey/[id].vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/table-program',
    name: 'table-program',
    component: () => import('D:/Projects/deploying-vue-bo/boe-int-fe/src/pages/table-program.vue'),
    /* no children */
  },
  _definePage_default_14
  )
]
